// TODO MS migrate to TypeScript

export default class Predicate {
    constructor(id, negated = false, predicateDefinitionId = 0, parameterValue = { value: null }, type = 'atomic') {
        this.type = type;
        this.filterCriteriaId = id;
        this.negated = negated;
        this.predicateDefinitionId = predicateDefinitionId;
        this.parameterValue = parameterValue;
    }

    get id() {
        return this.filterCriteriaId;
    }

    get value() {
        return this.parameterValue.value;
    }

    set value(value) {
        this.parameterValue.value = value;
    }
}
